module.exports = __webpack_public_path__ + "static/media/slideshow.e27338fa.svg";